// Land for the home page's iPad chart of Gallivant's anchorage (TOM-980), as SVG
// path data in the chart's 520 x 590 viewBox (chartProjection.ts), one decimal.
//
// Source: OpenStreetMap, natural=coastline ways, fetched from the Overpass API
// (https://overpass-api.de/api/interpreter) on 1 November 2026, 7:36 PM PST.
// The response's timestamp_osm_base is 2026-11-02T03:36:14Z. The query, for the
// chart's viewBox plus 150 units (about 170 m) on every side:
//   [out:json][timeout:90];way["natural"="coastline"](50.129412,-124.931233,50.138374,-124.918352);out geom;
// It returned ways 149721307, 149721331, 149722054, 149722074, 592828101 and
// 592828113. Only 592828113 (the Cortes Island shore) and 149722074 (Protection
// Island) reach into the chart; the rest lie outside it.
//
// The water label's name is OSM relation 8345124 (natural=bay, name=Squirrel Cove):
//   [out:json][timeout:90];rel(8345124);out geom;
// The anchor and the label position lie inside that relation's polygon and
// outside the land.
//
// How the land was built: the ways were stitched end to end by shared node id,
// projected with projectToChart, and clipped to the viewBox plus 2 units. OSM
// coastlines run with land on the left, so each piece that leaves the box is
// closed along the box edge counter-clockwise (as drawn, north up) to the next
// piece that enters it. A closed way wholly inside the box would be an island
// as it stands; none is.
//
// Licence: this path data is derived from OpenStreetMap and is available under
// the Open Database License 1.0 (https://opendatacommons.org/licenses/odbl/1-0/).
// The chart must show ANCHORAGE_LAND_ATTRIBUTION where it is seen.

/** One closed land area per entry, wound counter-clockwise as drawn. */
const LAND_AREAS = [
  // Protection Island, with its inlet at the right edge.
  'M522.0 290.8L517.5 290.6L500.8 265.1L499.5 249.9L508.1 235.4L513.4 233.5L522.0 236.4L522.0 135.3L518.8 132.5L510.7 130.8L503.6 134.6L493.4 147.3L488.8 148.3L469.7 128.4L453.7 131.5L443.3 139.7L434.7 152.4L420.7 200.2L411.8 269.1L413.3 287.9L419.0 302.1L420.3 318.0L417.1 335.2L408.5 348.7L394.7 396.4L388.4 432.3L389.0 452.0L397.7 482.1L417.1 508.4L430.7 517.1L445.8 516.6L483.5 493.3L497.9 496.6L505.3 508.0L519.7 515.6L522.0 515.1Z',
  // Cortes Island, the shore at the bottom middle.
  'M420.7 592.0L418.3 587.9L387.0 551.1L375.2 545.2L368.2 545.5L345.6 592.0Z',
  // Cortes Island, the shore at the bottom left.
  'M213.9 592.0L184.4 572.5L171.9 567.6L155.8 566.1L137.4 580.0L124.2 586.7L107.3 590.6L73.4 588.8L58.1 579.4L36.9 550.4L30.3 536.3L31.0 528.2L46.5 511.8L43.4 493.2L47.5 477.7L47.1 464.4L45.3 461.8L27.4 457.8L13.8 449.2L1.9 437.9L-2.0 432.0L-2.0 592.0Z',
  // Cortes Island, the shore at the top left.
  'M-2.0 100.6L0.2 98.5L16.6 75.7L30.9 43.2L42.3 31.3L49.8 16.7L56.5 -2.0L-2.0 -2.0Z',
];

/** Every land area as one path's data; fill it with fill-rule nonzero. */
export const ANCHORAGE_LAND_D = LAND_AREAS.join('');

/**
 * The water label. The name is OSM's (relation 8345124); the position is the
 * approved design's, in water inside that bay.
 */
export const ANCHORAGE_WATER_LABEL = { name: 'Squirrel Cove', x: 390, y: 70 } as const;

export const ANCHORAGE_LAND_ATTRIBUTION = '© OpenStreetMap contributors';
export const ANCHORAGE_LAND_ATTRIBUTION_URL = 'https://www.openstreetmap.org/copyright';
